import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const checkOutboundSubRouter = () => {
  const { t } = useI18n();
  const store = useStore();
  const sessionToken = store.getters["auth/getSessionToken"]();
  const clientInfo = store.getters["auth/getClientInfo"]();
  const routers = [
    {
      path: "parcel",
      name: t("router.outbound-parcel"),
    },
    {
      path: "quick",
      name: t("router.outbound-quick"),
    },
    {
      path: "mass-parcel",
      name: t("router.outbound-mass-parcel"),
    },
  ];
  if (!sessionToken) return routers;

  if (clientInfo.registeredMail && clientInfo.registeredMail.enabled)
    routers.push({
      path: "registry",
      name: t("router.outbound-registry"),
    });

  if (
    clientInfo.ems &&
    clientInfo.ems.enabled &&
    clientInfo.dhl &&
    clientInfo.dhl.enabled
  )
    routers.push({
      path: "global",
      name: t("router.outbound-global"),
    });

  return routers;
};

const useRenderRouter = () => {
  const { t } = useI18n();
  const router = useRouter();
  const store = useStore();
  const routerList = [
    // 주문접수

    {
      path: "/outbound",
      name: t("router.outbound"),
      children: checkOutboundSubRouter(),
    },

    // 주문조회

    {
      path: "/tracking",
      name: t("router.tracking"),
      children: [
        {
          path: "outbound",
          name: t("router.tracking-outbound"),
        },
      ],
    },

    // 고객지원

    {
      name: t("router.help"),
      path: "/help",
      children: [
        {
          path: "notice",
          name: t("router.help-notice"),
        },
        {
          path: "faq",
          name: t("router.help-faq"),
        },
      ],
    },
    // 서비스 소개

    {
      path: "/service",
      name: "서비스소개",
    },
  ];

  // 마이페이지
  const mypageRouterList = {
    path: "/mypage",
    name: t("router.mypage"),
    children: [
      {
        path: "profile",
        name: t("router.mypage-profile"),
      },
      {
        path: "billing",
        name: t("router.mypage-billing"),
      },
      {
        path: "unit",
        name: t("router.mypage-unit"),
      },
    ],
  };

  const actionSignOut = () => {
    store.dispatch("auth/updateSessionToken", "");
    store.dispatch("auth/updateClientInfo", {
      name: "",
    });
    store.dispatch("auth/updateCenterInfo", {
      name: "",
    });
    store.dispatch("localStorage/saveToLocalStorage");
    router.push("/");
  };
  return {
    router,
    routerList,
    mypageRouterList,
    actionSignOut,
  };
};

export default useRenderRouter;
